module.exports = __webpack_public_path__ + "static/9heartwarminggames0-0b60d54d5a4b5b0f46cf8d5f7fd9fca8.png";